import { render, staticRenderFns } from "./NewCV.html?vue&type=template&id=b0dcc6c0&scoped=true&"
import script from "./NewCV.vue?vue&type=script&lang=js&"
export * from "./NewCV.vue?vue&type=script&lang=js&"
import style0 from "./NewCV.scss?vue&type=style&index=0&id=b0dcc6c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dcc6c0",
  null
  
)

export default component.exports